/**
 * Created by markusr on 9.6.2015.
 * @component {"type":"TaskSettings","version":"1.1"}
 */

define('task',['knockout', 'helpers', 'task-open-question', 'task-yes-no-question', 'task-match-pair', 'task-sort-to-groups', 'task-evaluate'], function(ko, helpers, OpenQuestion, YesNoQuestion, MatchPair, SortToGroups, Evaluate) {
    'use strict';

    return function(parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.answers = ko.computed(function() {
            return entityVM.answersJS();
        });

        self.questions = ko.computed(function() {
            return entityVM.questionsJS();
        });

        self.containsAnswers = ko.computed(function() {
            return !!trainingVM.computedAnswers().length;
        });

        self.isEnabled = ko.computed(function() {
            return trainingVM.answersEnabled();
        });

        self.isAnswered = ko.computed(function() {
            return trainingVM.isTaskAnswered() || !trainingVM.answersEnabled();
        });

        self.openQuestion = new OpenQuestion(parentVM, dataContext);

        self.YesNoQuestion = new YesNoQuestion(parentVM, dataContext);

        self.matchPair = new MatchPair(parentVM, dataContext, self);

        self.sortToGroups = new SortToGroups(parentVM, dataContext, self);

        self.evaluate = new Evaluate(parentVM, dataContext, self);

        self.submit = function(obj, e) {
            var arr;

            if (entityVM.typeID() === 16) {   // Match pair

                if (!trainingVM.isValid()) {
                    trainingVM.submitForm(obj, e, arr);
                } else {

                    if (self.matchPair.getVersion()) {
                        arr = self.matchPair.getAnswers(self.questions());
                    } else {
                        arr = self.matchPair.getAnswersDraggable(self.questions());
                    }

                    if (trainingVM.isValid()) {
                        trainingVM.submitForm(obj, e, arr);
                    }
                }

            } else {
                trainingVM.submitForm(obj, e, arr);
            }
        };

        self.reset = function(reload) {
            trainingVM.resetForm(reload);
        };
    }
});


